import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface AirportTransferHighlight {
  id: string
  imageId: string
  title: string
  description: string
}

function useAirportTransferHighlights(): Array<AirportTransferHighlight> {
  const intl = useIntl()

  return useMemo(() => ([
    {
      id: 'find-transfer',
      imageId: 'cars-page-transfer-how-it-works-transfer',
      title: intl.formatMessage({
        id: 'EiSokBgqacxCvpu1aOXV',
        defaultMessage: 'Find the right transfer',
        description: 'Airport transfer step title about selecting the most suitable transfer',
      }),
      description: intl.formatMessage({
        id: '6WOGc_bLcuBwRfAgPGhg',
        defaultMessage: 'Pick from private cars, shared shuttles and spacious options for bigger groups.',
        description: 'Airport transfer step description about vehicle and shuttle choices',
      }),
    },
    {
      id: 'book-with-confidence',
      imageId: 'cars-page-transfer-how-it-works-book-with-confidence',
      title: intl.formatMessage({
        id: 'Lmpb3x3lkuJJT1s_PMiM',
        defaultMessage: 'Book with confidence',
        description: 'Airport transfer step title about booking confidence and flexibility',
      }),
      description: intl.formatMessage({
        id: 'nRGOvhWVN6j-WKuzImRk',
        defaultMessage: 'Confirmation is immediate. Cancel free up to 24 hours before pick-up if plans change.',
        description: 'Airport transfer step description about confirmation and cancellation flexibility',
      }),
    },
    {
      id: 'meet-your-driver',
      imageId: 'cars-page-transfer-how-it-works-driver',
      title: intl.formatMessage({
        id: 'jEBVmsZ7NjMBtwzmXy1-',
        defaultMessage: 'Meet your driver',
        description: 'Airport transfer step title about meeting the driver on arrival',
      }),
      description: intl.formatMessage({
        id: 'h4oIHENDmtQCRnxSEkBQ',
        defaultMessage: 'Your driver will be waiting at the meeting point, with free waiting for 45 minutes and flight tracking for delays up to 3 hours.',
        description: 'Airport transfer step description about included waiting and flight-delay tracking',
      }),
    },
  ]), [intl])
}

export default useAirportTransferHighlights
